<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <v-container>

        <v-layout align-start justify-space-between row fill-height>
            <div></div>
            <div class="text-xs-center pt-2">

            </div>
            <v-tooltip top>

                <v-btn @click.native="createFinalObject"
                        slot="activator"
                        round
                        class="mr-5"
                        color="info">
                    <span class="editButton">Συνέχεια</span>
                    <v-icon>keyboard_arrow_right</v-icon>
                </v-btn>
                <span>Πατήστε "Συνέχεια" για να δείτε τα στοιχεία που έχετε καταχωρίσει και να ολοκληρώσετε τη δήλωσή σας</span>
            </v-tooltip>
        </v-layout>

        <hr/>

        <v-layout row>
            <v-expansion-panel popout @expand="onClickPanel($event, n)">
                <v-expansion-panel-content
                        ripple
                        class="elevation-1"
                        v-for="(item, n) in $store.getters.semesterData"
                        @input="onInput($event, n)" @focus="$emit($event, n)"
                        :value="n==currSection" :key="`expansion-${n}`">

                    <div slot="header" v-if="item.semester == 0">
                        Χωρίς Εξάμηνο
                        <v-tooltip v-if="item.courseRegistration" left>
                            <template slot="activator" slot-scope="{ on }">
                                <v-icon class="right" color="red" v-on="on">warning</v-icon>
                            </template>
                            <span>Υπάρχει μάθημα για το οποίο δεν δικαιούστε το σύγγραμμα</span>
                        </v-tooltip>
                    </div>
                    <div slot="header" v-else>
                       {{item.semester}}o Εξάμηνο
                        <v-tooltip v-if="item.courseRegistration" top>
                            <template slot="activator" slot-scope="{ on }">
                                <v-icon class="right" color="red" v-on="on">warning</v-icon>
                            </template>
                            <span>Υπάρχει μάθημα για το οποίο δεν δικαιούστε το σύγγραμμα</span>
                        </v-tooltip>
                    </div>


                    <test-component :dynamicKey="componentKey" :semesterInfo="item.semesterInfo" :semester="item.semester" @addToArray="addToArray" @removeToArray="removeToArray"/>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-layout>
    </v-container>
</template>

<script>
    import testComponent from "../TestComponents/testComponent";
    import utilities from "../../utilities"
    import request from "../../requests"

    export default {
        name: "StudentDepartmentComponent",
        components: {testComponent},
        data() {
            return {
                active: {},
                bookItem: null,
                checkedBooks: this.$store.getters.checkedBooks,
                panel:[],
                CONST_TRUE: true,
                dialog: false,
                focusable: false,
                semestersArrays: this.$store.getters.semesters,
                componentKey: 0,
                currSection: -1,
                openSection: true,
            }
        },
        methods: {
            onClickPanel(ev, n) {
                // console.log("Section click:", n + 1, ev);
                // this.componentKey += 1;
            },
            //on click event on the expansion panel re render the test component
            // with pass a dynamic key to component
            onInput (isOpen, n) {
                if (this.currSection == -1) {
                    this.currSection = n;
                }
                else if (n != this.currSection){
                    this.currSection = n;
                    this.componentKey += 1;
                }
            },
            closeDialog(){
                var flag = false;
                this.$store.commit('setDialog', flag)
            },

            addToArray(object){
	            console.log(object);
	            this.checkedBooks[object.item.courseIno.id] = {books:object.item.courseBooks[object.j], period:object.item.courseBooks[object.j].course.period, date:this.$store.getters.active.date};
                var redeemPoints = utilities.redeemPointsById(this.checkedBooks, this.$store.getters.redeemPoints);
	            console.log(this.checkedBooks);
	            console.log(redeemPoints);
                if (Object.keys(redeemPoints).length > 0) {
                    for (var redeemPoint in redeemPoints) {
                        redeemPoints[redeemPoint].books.statementBookGroupType = 'CREDIT'
                    }
                }
                //I added this part for ticket StudentApp2-FrontEnd#45 if a book is selected by redeem and then at edit statement it gets selected by statement(checkedBooks)
                // it is removed from redeem list but added in checkedBooks list with the wrong type though. It appears that the books are grouped in the various front end components
                // by the store (redeemPoints, checkedBooks) so they appear in the "correct spot" but the type that gets send in the request is wrong.
                if (Object.keys(this.checkedBooks).length > 0) {
                    for (var checkedBook in this.checkedBooks) {
	                    this.checkedBooks[checkedBook].books.statementBookGroupType = 'NORMAL'
                    }
                }

	            console.log('after');
	            console.log(this.checkedBooks);
	            console.log(redeemPoints);
                this.$store.commit('setRedeemPoints', redeemPoints);
                this.$store.commit('setCheckedBooks', this.checkedBooks);
                this.enableCousreWarning(object.item.courseIno.semester);
            },

            removeToArray(object){
                delete this.checkedBooks[object.item.courseIno.id];
                this.$store.commit('setCheckedBooks', this.checkedBooks);
                this.$store.commit('setStatementBookGroup', null);
                this.disableWarnings(object.item.courseIno.semester, object.item.courseIno.id);
            },

            createFinalObject(){

                var webservicestatus  = this.$store.getters.login.academic.webservicestatus;
                var coursesCodes = [];
                var checkedBooks = this.$store.getters.checkedBooks;

                for (var checkedBook in checkedBooks) {
                    coursesCodes.push(checkedBook)
                }


                if (webservicestatus && coursesCodes.length > 0) {
                    this.$store.commit('setLoadingModal', true);
                    request.checkCourceRegistration(coursesCodes, this.successCheckCourceRegistration)
                }
                else {
                    this.$store.commit('setCourseRegistration' , []);
                    if(this.$store.getters.login.exchangeCredits > 0){
                        this.$router.push({path: '/redeemPoints'});
                    }
                    else {
                        this.$router.push({path: '/statementBookList'});
                    }
                }
            },

            successCheckCourceRegistration(response){

                this.$store.commit('setCourseRegistration' , response);
                var countCourses = 0;
                var message = {};
                message.warningTitle = 'Προσοχή!';
                message.warningMessage = ' Έχετε επιλέξει συγγράμματα για μαθήματα τα οποία δεν έχετε δηλώσει στη Γραμματεία της Σχολής σας. Τα παρακάτω μαθήματα θα πρέπει είτε να τα δηλώσετε στη Γραμματεία σας είτε να τα αποεπιλέξετε για να συνεχίσετε';
                // message.message += '<v-tooltipleft><template v-slot:activator="{ on }"><v-icon class="right" color="red" v-on="on">warning</v-icon></template><span>Δεν δικαιούστε το σύγγραμμα</span></v-tooltip>';
                message.close = true;
                if (response.length > 0 ){
                    message.warningList = '';
                    response.forEach(function (el) {
                        if (!el.registrationFound) {
                            if(el.courseDTO.code){
                                message.warningList += '<li><v-list-item><v-list-item-content><v-list-item-title>'+ '[' + el.courseDTO.code +']'  + ' '+ el.courseDTO.title +'</v-list-item-title></v-list-item-content></v-list-item>'
                            }else{
                                message.warningList += '<li><v-list-item><v-list-item-content><v-list-item-title>'+ el.courseDTO.title +  '</v-list-item-title></v-list-item-content></v-list-item>'
                            }
                            countCourses++;
                        }
                    });
                }
                if (countCourses > 0) {
                    this.enableWarnings();
                    this.$store.commit('setMessageObject', message);
                    this.$store.commit('setMessageModal', true);
                }
                else {
                    if(this.$store.getters.login.exchangeCredits > 0){
                        this.$router.push({path: '/redeemPoints'});
                    }
                    else {
                        this.$router.push({path: '/statementBookList'});
                    }
                }
                this.$store.commit('setLoadingModal', false);
            },
            // enable warnings with request response
            enableWarnings() {

                var courseRegistration =  this.$store.getters.courseRegistration;
                var semesterData = this.$store.getters.semesterData;

                courseRegistration.forEach(function (reg) {
                    var semester = reg.courseDTO.semester;
                    if (!reg.registrationFound) {
                        semesterData.forEach(function (sem) {
                            if (sem.semester == semester) {
                                sem.courseRegistration = true;
                                sem.semesterInfo.forEach(function (semInfo) {
                                    if (semInfo.courseIno.id == reg.courseDTO.id) {
                                        semInfo.courseRegistration = true
                                    }
                                })
                            }
                        })
                    }
                });
                this.$store.commit('setSemesterData', semesterData);
            },
            //disable the current warning (course or semester)
            disableWarnings(semester, courseId) {

                var courseRegistration =  this.$store.getters.courseRegistration;
                var semesterData = this.$store.getters.semesterData;
                var checkedBooks = this.$store.getters.checkedBooks;
                var countSemester = 0;

                courseRegistration.forEach(function (reg) {
                   if (checkedBooks.hasOwnProperty(reg.courseDTO.id)) {
                       if (checkedBooks[reg.courseDTO.id].books.course.semester == semester
                       && !reg.registrationFound) {
                           countSemester++
                       }
                   }
                });


                if (countSemester == 0) {
                    semesterData.forEach(function (sem) {
                        if (sem.semester == semester) {
                            sem.courseRegistration = false;
                            sem.semesterInfo.forEach(function (semInfo) {
                                if (semInfo.courseIno.id == courseId) {
                                    semInfo.courseRegistration = false;
                                }
                            })
                        }
                    })
                }
                else {
                    semesterData.forEach(function (sem) {
                        if (sem.semester == semester) {
                            sem.semesterInfo.forEach(function (semInfo) {
                                if (semInfo.courseIno.id == courseId) {
                                    semInfo.courseRegistration = false;
                                }
                            })
                        }
                    })
                }
                this.$store.commit('setSemesterData', semesterData);
            },
            //enable the current warning (course or semester) if book to add is exist in courseRegistration response
            enableCousreWarning(semester) {
                var courseRegistration =  this.$store.getters.courseRegistration;
                var semesterData = this.$store.getters.semesterData;
                var checkedBooks = this.$store.getters.checkedBooks;

                courseRegistration.forEach(function (reg) {
                    if (checkedBooks.hasOwnProperty(reg.courseDTO.id)) {
                        if (checkedBooks[reg.courseDTO.id].books.course.semester == semester
                            && !reg.registrationFound) {
                            semesterData.forEach(function (semData) {
                                if (semData.semester == semester) {
                                    semData.courseRegistration = true;
                                    semData.semesterInfo.forEach(function (semInfo) {
                                        if (semInfo.courseIno.id == reg.courseDTO.id) {
                                            semInfo.courseRegistration = true;
                                        }
                                    })
                                }
                            })
                        }
                    }
                });
                this.$store.commit('setSemesterData', semesterData);
            }
        },
        computed: {
            semesterDataCount() {
                return this.$store.state.semesterData.length
            }
        },
        watch: {
            semesterDataCount() {
                if (this.$store.getters.semesterData.length > 0)
                    this.$store.commit('setLoadingModal', false);
            }
        },
        created() {
            this.active = this.$store.getters.active;

            if (this.$store.getters.semesterData == null) {
                this.$store.commit('setLoadingModal', false);
            }
            if (this.$store.getters.semesterData.length > 0){
                this.$store.commit('setLoadingModal', false);
            }
        }
    }
</script>

<style scoped>

    .editButton {
        font-size: small;
        padding-right: 5px;
    }

</style>
